import Book from '../assets/Book.jpg';
import CC from '../assets/CC.jpeg';
import Forest from '../assets/Forest.jpg';
import Girlswing from '../assets/Girlswing.jpg';
import Glacier from '../assets/Glacier.jpg';
import Lakeview from '../assets/Lakeview.jpg';
import Laptop from '../assets/Laptop.jpg';
import Mountain from '../assets/Mountain.jpg';
import OB from '../assets/OB.jpg';
import OC from '../assets/OC.jpg';
import OF from '../assets/OF.jpg';
import OG from '../assets/OG.jpg';
import OM from '../assets/OM.jpg';
import OP from '../assets/OP.jpg';
import OR from '../assets/OR.jpg';
import OT from '../assets/OT.jpg';

export default { Book, CC, Forest, Girlswing, Glacier, Lakeview, Laptop, Mountain, OB, OC, OF, OG, OM, OP, OR, OT };
